/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'

const AuthIndexLazyRouteImport = createFileRoute('/_auth/')()
const AuthenticatedActivateIndexLazyRouteImport = createFileRoute(
  '/_authenticated/activate/',
)()
const AuthenticatedApplicationsApplicationIdLazyRouteImport = createFileRoute(
  '/_authenticated/applications/$applicationId',
)()
const AuthenticatedCandidatesIndexLazyRouteImport = createFileRoute(
  '/_authenticated/candidates/',
)()
const AuthenticatedCandidatesCandidateIdLazyRouteImport = createFileRoute(
  '/_authenticated/candidates/$candidateId',
)()
const AuthenticatedCommissionsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/commissions/',
)()
const AuthenticatedHomeIndexLazyRouteImport = createFileRoute(
  '/_authenticated/home/',
)()
const AuthenticatedProfileIndexLazyRouteImport = createFileRoute(
  '/_authenticated/profile/',
)()
const AuthenticatedProgramsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/programs/',
)()
const AuthenticatedProgramsProgramIdLazyRouteImport = createFileRoute(
  '/_authenticated/programs/$programId',
)()
const AuthenticatedTreeIndexLazyRouteImport = createFileRoute(
  '/_authenticated/tree/',
)()
const AuthenticatedTreeAgentIdLazyRouteImport = createFileRoute(
  '/_authenticated/tree/$agentId',
)()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexLazyRoute = AuthIndexLazyRouteImport.update({
  id: '/_auth/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_auth/index.lazy').then((d) => d.Route))
const AuthenticatedActivateIndexLazyRoute =
  AuthenticatedActivateIndexLazyRouteImport.update({
    id: '/activate/',
    path: '/activate/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/activate/index.lazy').then((d) => d.Route),
  )
const AuthenticatedApplicationsApplicationIdLazyRoute =
  AuthenticatedApplicationsApplicationIdLazyRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/applications/$applicationId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCandidatesIndexLazyRoute =
  AuthenticatedCandidatesIndexLazyRouteImport.update({
    id: '/candidates/',
    path: '/candidates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/candidates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCandidatesCandidateIdLazyRoute =
  AuthenticatedCandidatesCandidateIdLazyRouteImport.update({
    id: '/candidates/$candidateId',
    path: '/candidates/$candidateId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/candidates/$candidateId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCommissionsIndexLazyRoute =
  AuthenticatedCommissionsIndexLazyRouteImport.update({
    id: '/commissions/',
    path: '/commissions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/commissions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedHomeIndexLazyRoute =
  AuthenticatedHomeIndexLazyRouteImport.update({
    id: '/home/',
    path: '/home/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/home/index.lazy').then((d) => d.Route),
  )
const AuthenticatedProfileIndexLazyRoute =
  AuthenticatedProfileIndexLazyRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/profile/index.lazy').then((d) => d.Route),
  )
const AuthenticatedProgramsIndexLazyRoute =
  AuthenticatedProgramsIndexLazyRouteImport.update({
    id: '/programs/',
    path: '/programs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/programs/index.lazy').then((d) => d.Route),
  )
const AuthenticatedProgramsProgramIdLazyRoute =
  AuthenticatedProgramsProgramIdLazyRouteImport.update({
    id: '/programs/$programId',
    path: '/programs/$programId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/programs/$programId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedTreeIndexLazyRoute =
  AuthenticatedTreeIndexLazyRouteImport.update({
    id: '/tree/',
    path: '/tree/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tree/index.lazy').then((d) => d.Route),
  )
const AuthenticatedTreeAgentIdLazyRoute =
  AuthenticatedTreeAgentIdLazyRouteImport.update({
    id: '/tree/$agentId',
    path: '/tree/$agentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/tree/$agentId.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexLazyRoute
  '/applications/$applicationId': typeof AuthenticatedApplicationsApplicationIdLazyRoute
  '/candidates/$candidateId': typeof AuthenticatedCandidatesCandidateIdLazyRoute
  '/programs/$programId': typeof AuthenticatedProgramsProgramIdLazyRoute
  '/tree/$agentId': typeof AuthenticatedTreeAgentIdLazyRoute
  '/activate/': typeof AuthenticatedActivateIndexLazyRoute
  '/candidates/': typeof AuthenticatedCandidatesIndexLazyRoute
  '/commissions/': typeof AuthenticatedCommissionsIndexLazyRoute
  '/home/': typeof AuthenticatedHomeIndexLazyRoute
  '/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/programs/': typeof AuthenticatedProgramsIndexLazyRoute
  '/tree/': typeof AuthenticatedTreeIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexLazyRoute
  '/applications/$applicationId': typeof AuthenticatedApplicationsApplicationIdLazyRoute
  '/candidates/$candidateId': typeof AuthenticatedCandidatesCandidateIdLazyRoute
  '/programs/$programId': typeof AuthenticatedProgramsProgramIdLazyRoute
  '/tree/$agentId': typeof AuthenticatedTreeAgentIdLazyRoute
  '/activate': typeof AuthenticatedActivateIndexLazyRoute
  '/candidates': typeof AuthenticatedCandidatesIndexLazyRoute
  '/commissions': typeof AuthenticatedCommissionsIndexLazyRoute
  '/home': typeof AuthenticatedHomeIndexLazyRoute
  '/profile': typeof AuthenticatedProfileIndexLazyRoute
  '/programs': typeof AuthenticatedProgramsIndexLazyRoute
  '/tree': typeof AuthenticatedTreeIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_auth/': typeof AuthIndexLazyRoute
  '/_authenticated/applications/$applicationId': typeof AuthenticatedApplicationsApplicationIdLazyRoute
  '/_authenticated/candidates/$candidateId': typeof AuthenticatedCandidatesCandidateIdLazyRoute
  '/_authenticated/programs/$programId': typeof AuthenticatedProgramsProgramIdLazyRoute
  '/_authenticated/tree/$agentId': typeof AuthenticatedTreeAgentIdLazyRoute
  '/_authenticated/activate/': typeof AuthenticatedActivateIndexLazyRoute
  '/_authenticated/candidates/': typeof AuthenticatedCandidatesIndexLazyRoute
  '/_authenticated/commissions/': typeof AuthenticatedCommissionsIndexLazyRoute
  '/_authenticated/home/': typeof AuthenticatedHomeIndexLazyRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/_authenticated/programs/': typeof AuthenticatedProgramsIndexLazyRoute
  '/_authenticated/tree/': typeof AuthenticatedTreeIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/applications/$applicationId'
    | '/candidates/$candidateId'
    | '/programs/$programId'
    | '/tree/$agentId'
    | '/activate/'
    | '/candidates/'
    | '/commissions/'
    | '/home/'
    | '/profile/'
    | '/programs/'
    | '/tree/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/applications/$applicationId'
    | '/candidates/$candidateId'
    | '/programs/$programId'
    | '/tree/$agentId'
    | '/activate'
    | '/candidates'
    | '/commissions'
    | '/home'
    | '/profile'
    | '/programs'
    | '/tree'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_auth/'
    | '/_authenticated/applications/$applicationId'
    | '/_authenticated/candidates/$candidateId'
    | '/_authenticated/programs/$programId'
    | '/_authenticated/tree/$agentId'
    | '/_authenticated/activate/'
    | '/_authenticated/candidates/'
    | '/_authenticated/commissions/'
    | '/_authenticated/home/'
    | '/_authenticated/profile/'
    | '/_authenticated/programs/'
    | '/_authenticated/tree/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthIndexLazyRoute: typeof AuthIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/activate/': {
      id: '/_authenticated/activate/'
      path: '/activate'
      fullPath: '/activate/'
      preLoaderRoute: typeof AuthenticatedActivateIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/applications/$applicationId': {
      id: '/_authenticated/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/applications/$applicationId'
      preLoaderRoute: typeof AuthenticatedApplicationsApplicationIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/candidates/': {
      id: '/_authenticated/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof AuthenticatedCandidatesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/candidates/$candidateId': {
      id: '/_authenticated/candidates/$candidateId'
      path: '/candidates/$candidateId'
      fullPath: '/candidates/$candidateId'
      preLoaderRoute: typeof AuthenticatedCandidatesCandidateIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/commissions/': {
      id: '/_authenticated/commissions/'
      path: '/commissions'
      fullPath: '/commissions/'
      preLoaderRoute: typeof AuthenticatedCommissionsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthenticatedHomeIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/programs/': {
      id: '/_authenticated/programs/'
      path: '/programs'
      fullPath: '/programs/'
      preLoaderRoute: typeof AuthenticatedProgramsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/programs/$programId': {
      id: '/_authenticated/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/programs/$programId'
      preLoaderRoute: typeof AuthenticatedProgramsProgramIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tree/': {
      id: '/_authenticated/tree/'
      path: '/tree'
      fullPath: '/tree/'
      preLoaderRoute: typeof AuthenticatedTreeIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tree/$agentId': {
      id: '/_authenticated/tree/$agentId'
      path: '/tree/$agentId'
      fullPath: '/tree/$agentId'
      preLoaderRoute: typeof AuthenticatedTreeAgentIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedApplicationsApplicationIdLazyRoute: typeof AuthenticatedApplicationsApplicationIdLazyRoute
  AuthenticatedCandidatesCandidateIdLazyRoute: typeof AuthenticatedCandidatesCandidateIdLazyRoute
  AuthenticatedProgramsProgramIdLazyRoute: typeof AuthenticatedProgramsProgramIdLazyRoute
  AuthenticatedTreeAgentIdLazyRoute: typeof AuthenticatedTreeAgentIdLazyRoute
  AuthenticatedActivateIndexLazyRoute: typeof AuthenticatedActivateIndexLazyRoute
  AuthenticatedCandidatesIndexLazyRoute: typeof AuthenticatedCandidatesIndexLazyRoute
  AuthenticatedCommissionsIndexLazyRoute: typeof AuthenticatedCommissionsIndexLazyRoute
  AuthenticatedHomeIndexLazyRoute: typeof AuthenticatedHomeIndexLazyRoute
  AuthenticatedProfileIndexLazyRoute: typeof AuthenticatedProfileIndexLazyRoute
  AuthenticatedProgramsIndexLazyRoute: typeof AuthenticatedProgramsIndexLazyRoute
  AuthenticatedTreeIndexLazyRoute: typeof AuthenticatedTreeIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedApplicationsApplicationIdLazyRoute:
    AuthenticatedApplicationsApplicationIdLazyRoute,
  AuthenticatedCandidatesCandidateIdLazyRoute:
    AuthenticatedCandidatesCandidateIdLazyRoute,
  AuthenticatedProgramsProgramIdLazyRoute:
    AuthenticatedProgramsProgramIdLazyRoute,
  AuthenticatedTreeAgentIdLazyRoute: AuthenticatedTreeAgentIdLazyRoute,
  AuthenticatedActivateIndexLazyRoute: AuthenticatedActivateIndexLazyRoute,
  AuthenticatedCandidatesIndexLazyRoute: AuthenticatedCandidatesIndexLazyRoute,
  AuthenticatedCommissionsIndexLazyRoute:
    AuthenticatedCommissionsIndexLazyRoute,
  AuthenticatedHomeIndexLazyRoute: AuthenticatedHomeIndexLazyRoute,
  AuthenticatedProfileIndexLazyRoute: AuthenticatedProfileIndexLazyRoute,
  AuthenticatedProgramsIndexLazyRoute: AuthenticatedProgramsIndexLazyRoute,
  AuthenticatedTreeIndexLazyRoute: AuthenticatedTreeIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthIndexLazyRoute: AuthIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
